/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library ikmports
import { Component, createRef } from 'react';
import { Button, Row, Col, Form, Modal, Spinner } from 'react-bootstrap';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import axios from 'axios';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { ArrayValueReorder } from 'shared/modifiers';
import Datatable from 'shared/datatable';
import { sellerlist, locationlist, rolelist, staffdelete } from 'shared/settings/apiconfig';
import { ToasterMessage } from 'shared/toast/toast';

// style imports
import './StaffAgentsList.scss';
import { NoData } from 'features/components/redirect/NoData';

/**
 * Staff & Agents Page
 * 
 * @param props
 * 
 * @return html code for Staff & Agents list
 * 
**/

export class StaffAgentsList extends Component {

    config;
    initialSearchState;

    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            email: { field: 'email', value: '', op: 'LIKE', join: 'AND' },
            location: { field: 'location', value: '', op: 'LIKE', join: 'AND' },
            role: { field: 'role', value: '', op: 'LIKE', join: 'AND' }
        }

        this.state = {
            search: this.initialSearchState,
            searchData: false,
            tableData: [],
            issearch: false,
            locationList: [],
            roleList: [],
            StaffId: '',
            deleteModal:false,
            deleteLoading:false,
            deleteStatus: { show: false, type: '', message: '' },
            deleteRoleName: "",
            errorpageredirect: false,
            errorType: ''
        }
        this.config = {
            name: 'user',
            url: sellerlist,
            createurl: '/locations/staff-agents/create',
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['edit','delete'], customHeader: <> <div><Button className="save-button" onClick={() => this.navigateToEdit()}>+ Create</Button></div> </>, width: '100px',
                    actionEvents: { delete: (id) => { this.deleteAction(id) },edit: (row, state) => { this.props.history.push({ pathname: `/locations/staff-agents/edit/${row['locationid']}/${row['id']}`, state: state }) } }
                },
                { name: 'Role', property: 'role', sort: true, width: '150px' },
                { name: 'Name', property: 'lastname', sort: true, width: '180px', columnType: 'custom', customColumn: this.nameValue },
                { name: 'Email', property: 'email', sort: true, width: '200px' },
                { name: 'Location', property: 'location', sort: true, width: '150px' },
                { name: 'Status', property: 'active', sort: true, sortType: 'num-rev', width: '110px', columnType: 'custom', customColumn: this.statusValue },
                { name: 'Last Modified', property: 'modifieddate', sort: true, width: '210px', columnType: 'custom', customColumn: this.customDate }
            ],
            sort: [{ field: 'modifieddate', direction: 'desc' }],
            pagination: true,
            field: ['id', 'role', 'roleid', 'firstname', 'lastname', 'email', 'location', 'locationid', 'active', 'modifieddate']
        };
        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
            this.enableSearch();
        }
    }

    componentDidMount() {
        this.getLocationRoleList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack); 
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    nameValue = (values) => {
        return values['lastname'] + ', ' + values['firstname'];
    };

    statusValue = (values) => {
        if (values['active'])
            return 'Active';
        else
            return 'Inactive';
    }

    customDate = (value) => {
        if (value['modifieddate']) {
            return `${moment.utc(value['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    /* called when create clicked */
    navigateToEdit = () => {
        let data = {};
        data['datatable'] = this.state.tableData.stateData;
        this.props.history.push({ pathname: '/locations/staff-agents/create', state: data });
    }


    /* Get Location and role list */
    getLocationRoleList = async () => {
        await axios.all([
            await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
            await axios.post(getSellerUrl(rolelist), JSON.stringify({ field: ['id', 'name'] }), getSellerHeaders()),
        ])
            .then(response => {
                let locations = ArrayValueReorder(response[0].data.data, 'title');
                let role = ArrayValueReorder(response[1].data.data, 'name');
                this.setState({
                    locationList: locations,
                    roleList: role
                });
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            })
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            }
        }, () => {
            if (eventValue === '')
                this.checkSearch();
        });
    }

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value ?  this.state.search.firstname.value + '*' : '' },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value ?  this.state.search.lastname.value + '*' : '' },
            email: { ...this.state.search.email, value: this.state.search.email.value ? '*' + this.state.search.email.value + '*' : '' },
            location: { ...this.state.search.location, value: this.state.search.location.value ? this.state.search.location.value : '' },
            role: { ...this.state.search.role, value: this.state.search.role.value ? this.state.search.role.value : '' }
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }
    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }
    deleteAction = (id) => {
        this.setState({ 
            StaffId: id.id, 
            deleteModal: true , 
            deleteStatus: { show: false, type: '', message: '' },
            deleteRoleName: id.role
        })
    }
    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when table data changed */
    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }
    /* Called when delete button confirmed */
    deleteStaff = () => {
        this.setState({ deleteLoading: true });
        
        const data = {
        "staffid": this.state.StaffId,
        };
        axios.delete(getSellerUrl(staffdelete+this.state.StaffId), { ...getSellerHeaders(), data: { 'data': data } })
        .then(response => {
            if (response.status === 200) {
                this.enableSearch();
                this.setState({
                    ...this.state,
                    deleteLoading: false,
                    deleteStatus: { show: true, type: 'success', message: `${this.state.deleteRoleName} has been deleted successfully` }
                });
            } 
        })
        .catch(error => { 
            this.setState({
                ...this.state,
                deleteLoading:false,
                deleteStatus: { show: true, type: 'danger', message: error.response.data.message }
            });
        });
    }
    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {/* <div className="search-bar">
                    <form>
                        <input type="text" placeholder="Search" />
                    </form>
                </div> */}
                <div className="staff-search">
                    <div className="staff-list-search">
                        <Form className="staff-list-font">
                            <div className="staff-search-container">
                                <Row>
                                    <Col>
                                        <label>First Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="firstname" value={this.state.search.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>

                                    <Col>
                                        <label>Last Name</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="lastname" value={this.state.search.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Email</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="email" value={this.state.search.email.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col>
                                        <label>Location</label>
                                        <Form.Control as="select" name="location" value={this.state.search.location.value} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="">All</option>
                                            {
                                                this.state.locationList.map((loc, idx) => <option key={idx} value={loc.title}>{loc.title}</option>)
                                            }
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Role</label>
                                        <Form.Control as="select" name="role" value={this.state.search.role.value} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" >All</option>
                                            {this.state.roleList.map((role, index) =>
                                                <option key={index} value={role.name}>{role.name}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                </Row>
                                <Row className="d-flex" style={{ marginBottom: "-1%" }}>
                                    <Col md={6}>
                                    </Col>
                                    <Col md={6}>
                                        <div className="buttonClass">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="staff-list">
                    {/* need to add props, as it provides the previous state of datatable */}
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
                <Modal centered show={this.state.deleteModal} size="md" animation={false} onHide={() => { this.setState({ deleteModal:false }) }} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                           Are you sure you want to delete this {this.state.deleteRoleName} ?
                           <div id="toaster" className={this.state.deleteStatus.show ? " d-flex flex-row align-items-center justify-content-center toaster" : ''}  style={{paddingTop: "3%"}} >
                           {
                               this.state.deleteStatus.show ?
                              <ToasterMessage type={this.state.deleteStatus.type} message={this.state.deleteStatus.message} className="alert-handle"></ToasterMessage>
                             : null
                            }
                         </div> 
                            <div className="d-flex flex-row mt-4">
                                <Button variant="outline-dark btn-white mx-2" style={{ width: '120px' }} onClick={() => { this.setState({ deleteModal:false }) }}>No</Button>
                                <Button variant="secondary mx-2" style={{ width: '120px' }} disabled={this.state.deleteStatus.type === 'success' || this.state.deleteStatus.type === 'danger'} onClick={() => this.deleteStaff()}>Yes {this.state.deleteLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
